import PropTypes from 'prop-types';
import {useState} from 'react';

import {
  ADYEN,
  AFINZ,
  AZULZINHA,
  BCJ,
  CIELO,
  CIELO_DIGITAL,
  CRESOL,
  FISERV,
  IFOOD,
  MERCADO_PAGO,
  PAG_SEGURO,
  PAY_GO,
  PORTOBANK,
  REDE,
  SAFRA,
  SICREDI,
  SITEF,
  STELO,
  STONE,
  SUMUP,
  TON,
  UNICRED,
  VERO,
  YUNO,
  GETNET,
  PICPAY,
  SIPAG_SICOOB,
  FOOD99,
  KEETA,
  QLUB,
  QLIC,
  TRIBANCO,
  BS2ADIQ,
  XP
} from '../../constants/psrs';

const Cielo = '/psrs/psr-cielo-v3.png';
const Vero = '/psrs/psr-vero-v3.png';
const Stelo = '/psrs/psr-stelo-v2.png';
const Stone = '/psrs/psr-stone-v2.png';
const Ton = '/psrs/psr-ton.png';
const PagSeguro = '/psrs/psr-pagseguro-novo-v2.png';
const MercadoPago = '/psrs/mercado-pago-logo-novo-v2.png';
const PayGo = '/psrs/psr-paygo-novo-v2.png';
const Sitef = '/psrs/psr-sitef.png';
const Adyen = '/psrs/psr-adyen.png';
const iFood = '/psrs/psr-ifood.svg';
const Rede = '/psrs/psr-rede.v2.png';
const Safrapay = '/psrs/psr-safrapay-v2.png';
const Yuno = '/psrs/psr-yuno-v1.png';
const Sumup = '/psrs/psr-sumup-v1.png';
const Fiserv = '/psrs/psr-bin-novo-v3.png';
const Azulzinha = '/psrs/psr-azulzinha-v3.svg';
const Sicredi = '/psrs/psr-sicredi-v2.png';
const Afinz = '/psrs/psr-afinz-v3.svg';
const Getnet = '/psrs/psr-getnet-v2.png';
const Picpay = '/psrs/psr-picpay.svg';
const SipagSicoob = '/psrs/psr-sipag-sicoob.svg';
const Food99 = '/psrs/psr-99food.png';
const Keeta = '/psrs/psr-keeta.svg';
const Qlub = '/psrs/psr-qlub.png';
const Qlic = '/psrs/psr-qlic.png';
const Unica = '/psrs/psr-unica-v2.png';
const Bs2Adiq = '/psrs/psr-bs2-adiq-v1.png';
const Xp = '/psrs/psr-xp-v1.png';
const Cresol = '/psrs/psr-cresol-v1.svg';
const Bcj = '/psrs/psr-bcj-v1.png';
const PortoBank = '/psrs/psr-portobank-v1.svg';
const Unicred = '/psrs/psr-unicred-v1.png';

import './Logo.style.scss';

const LogoPsr = (props) => {
  const [haveImage, setHaveImage] = useState(true);
  const setImage = () => {
    switch (props.psrId) {
      case CIELO:
        return Cielo;

      case CIELO_DIGITAL:
        return Cielo;

      case VERO:
        return Vero;

      case STELO:
        return Stelo;

      case STONE:
        return Stone;

      case TON:
        return Ton;

      case PAG_SEGURO:
        return PagSeguro;

      case MERCADO_PAGO:
        return MercadoPago;

      case PAY_GO:
        return PayGo;

      case SITEF:
        return Sitef;

      case ADYEN:
        return Adyen;

      case IFOOD:
        return iFood;

      case REDE:
        return Rede;

      case SAFRA:
        return Safrapay;

      case YUNO:
        return Yuno;

      case SUMUP:
        return Sumup;

      case FISERV:
        return Fiserv;

      case AZULZINHA:
        return Azulzinha;

      case SICREDI:
        return Sicredi;

      case SIPAG_SICOOB:
        return SipagSicoob;

      case AFINZ:
        return Afinz;

      case GETNET:
        return Getnet;

      case PICPAY:
        return Picpay;

      case FOOD99:
        return Food99;

      case KEETA:
        return Keeta;

      case QLUB:
        return Qlub;

      case QLIC:
        return Qlic;

      case TRIBANCO:
        return Unica;

      case BS2ADIQ:
        return Bs2Adiq;

      case XP:
        return Xp;

      case CRESOL:
        return Cresol;

      case BCJ:
        return Bcj;

      case PORTOBANK:
        return PortoBank;

      case UNICRED:
        return Unicred;

      default:
        setHaveImage(false);
    }
  };

  return (
    <>
      {haveImage && (
        <img src={setImage()} alt={`Logo da psr ${props.psrName}`} />
      )}
      {!haveImage && <p className="logo-name">{props.psrName}</p>}
    </>
  );
};

LogoPsr.propTypes = {
  psrId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  psrName: PropTypes.string
};

export default LogoPsr;
